import { GlobalsDao } from "../../dao";
import { ErrorModel } from "../../models";
import { getAllGlobalsSchema } from "./_schema/getAllGlobals.schema";
import { SERVICE_CODE } from "./_serviceCode";

const FUNCTION_CODE = 'GET_ALL_GLOBALS';

export async function getAllGlobals(userToken: string) {
    try {
        const result = await GlobalsDao.getAllGlobals(userToken);

        const parsedResponse = getAllGlobalsSchema.parse(result);

        return parsedResponse;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération des données globales',
            error: error
        });
    }
}